import api from '@/lib/api'

const LAST_COMPANY_ID_STORAGE_KEY = 'rankinai:last-company-id'
const DEFAULT_LOGIN_COMPANY_ID = 'ea0aadb8-d110-49cc-9256-f5b2f6fe4f06'

interface CompanyLike {
  id: string
}

export function buildCompanyOverviewPath(companyId: string) {
  return `/companies/${companyId}/overview`
}

export function getRememberedCompanyId() {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(LAST_COMPANY_ID_STORAGE_KEY)
}

export function rememberCompanyId(companyId: string) {
  if (typeof window === 'undefined') return
  localStorage.setItem(LAST_COMPANY_ID_STORAGE_KEY, companyId)
}

function resolvePreferredCompanyId<T extends CompanyLike>(companies: T[]) {
  const defaultCompany = companies.find((company) => company.id === DEFAULT_LOGIN_COMPANY_ID)
  if (defaultCompany) return defaultCompany.id

  const rememberedCompanyId = getRememberedCompanyId()

  if (rememberedCompanyId) {
    const rememberedCompany = companies.find((company) => company.id === rememberedCompanyId)
    if (rememberedCompany) return rememberedCompany.id
  }

  return companies[0]?.id ?? null
}

export async function resolvePostLoginPath() {
  const response = await api.get('/companies')
  const companies = Array.isArray(response.data?.companies)
    ? (response.data.companies as CompanyLike[])
    : []

  const preferredCompanyId = resolvePreferredCompanyId(companies)
  if (!preferredCompanyId) return '/companies/new'

  rememberCompanyId(preferredCompanyId)
  return buildCompanyOverviewPath(preferredCompanyId)
}
